import { track } from '../../utils/trackPulse';
// test if session storage is messing up the experiment tracking
const hasTrackedExperiment = (name, variant) => {
    var _a, _b, _c;
    try {
        const today = new Date().getUTCDay();
        const trackedExperiments = JSON.parse((_b = (_a = window === null || window === void 0 ? void 0 : window.sessionStorage) === null || _a === void 0 ? void 0 : _a.getItem('tracked-experiments')) !== null && _b !== void 0 ? _b : '{}');
        const experiment = trackedExperiments[name];
        if ((experiment === null || experiment === void 0 ? void 0 : experiment.variant) === variant && (experiment === null || experiment === void 0 ? void 0 : experiment.validDay) === today) {
            return true;
        }
        trackedExperiments[name] = {
            variant,
            validDay: today,
        };
        (_c = window === null || window === void 0 ? void 0 : window.sessionStorage) === null || _c === void 0 ? void 0 : _c.setItem('tracked-experiments', JSON.stringify(trackedExperiments));
        return false;
    }
    catch (error) {
        return false;
    }
};
export const trackExperiment = (name, variant, brand) => {
    // if (!hasTrackedExperiment(name, variant)) {
    track({
        type: 'View',
        intent: 'Load',
        name: 'Experiment exposure',
        object: {
            id: `sdrn:experiment:${name}_${variant}`,
            elementType: 'Experiment',
            type: 'UIElement',
        },
        experiments: [
            {
                id: `sdrn:experiment:${name}_${variant}`,
                platform: brand,
                variant: variant,
            },
        ],
    });
    // }
};
//# sourceMappingURL=utils.js.map